import React from 'react';

const ReviewCompletionBanner = ({ userHasReviewed, isEmployee, onReviewClick }) => {
  if (userHasReviewed) {
    return (
      <div style={{ 
        margin: '1.5rem',
        padding: '0'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(251, 84, 36, 0.15)',
          border: '2px solid #fb5424',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '150px',
            height: '150px',
            background: 'radial-gradient(circle, rgba(251, 84, 36, 0.1) 0%, transparent 70%)',
            borderRadius: '50%'
          }}></div>
          <div style={{
            fontSize: '2.5rem',
            marginBottom: '1rem',
            color: '#fb5424'
          }}>✓</div>
          <h3 style={{
            margin: '0 0 0.5rem 0',
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#9a3412',
            lineHeight: '1.3'
          }}>
            Trabajo completado
          </h3>
          <p style={{
            margin: '0',
            fontSize: '1rem',
            color: '#c2410c',
            lineHeight: '1.5'
          }}>
            Gracias por compartir tu experiencia
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      margin: '1.5rem',
      padding: '0'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #fef3f2 100%)',
        borderRadius: '12px',
        padding: '2rem',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(251, 84, 36, 0.15)',
        border: '2px solid #fb5424',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '150px',
          height: '150px',
          background: 'radial-gradient(circle, rgba(251, 84, 36, 0.1) 0%, transparent 70%)',
          borderRadius: '50%'
        }}></div>
        <div style={{
          fontSize: '2rem',
          marginBottom: '1rem',
          color: '#fb5424'
        }}>⭐</div>
        <h3 style={{
          margin: '0 0 0.75rem 0',
          fontSize: '1.5rem',
          fontWeight: '700',
          color: '#1f2937',
          lineHeight: '1.3'
        }}>
          ¡Trabajo completado!
        </h3>
        <p style={{
          margin: '0 0 1.5rem 0',
          fontSize: '1rem',
          color: '#6b7280',
          lineHeight: '1.5'
        }}>
          Comparte tu experiencia y ayuda a otros
        </p>
        <button
          onClick={onReviewClick}
          style={{
            padding: '16px 40px',
            background: 'linear-gradient(135deg, #fb5424 0%, #e0451a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '700',
            boxShadow: '0 4px 15px rgba(251, 84, 36, 0.4)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            textTransform: 'none',
            letterSpacing: '0.3px',
            position: 'relative',
            zIndex: 1
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, #e0451a 0%, #c93a15 100%)';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(251, 84, 36, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'linear-gradient(135deg, #fb5424 0%, #e0451a 100%)';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(251, 84, 36, 0.4)';
          }}
        >
          Dejar Reseña
        </button>
      </div>
    </div>
  );
};

export default ReviewCompletionBanner;

